module.exports = __webpack_public_path__ + "img/sld.337a353c.svg";